import { render, staticRenderFns } from "./bannerDetail.vue?vue&type=template&id=1f576efe&scoped=true"
import script from "./bannerDetail.vue?vue&type=script&lang=js"
export * from "./bannerDetail.vue?vue&type=script&lang=js"
import style0 from "./bannerDetail.vue?vue&type=style&index=0&id=1f576efe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f576efe",
  null
  
)

export default component.exports